<template>
  <busy-area :busy="loading">
    <slot
      v-if="file || url"
      :url="file || url"
      :type="mimeType"
      v-bind="$attrs"
    />
    <span v-else class="error" :class="{ styled }">
      <Cross />
      <span class="text-pre">{{ $t('invalidFile') }}</span>
    </span>
  </busy-area>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Cross from '@images/close.svg?component';
import { useObjectUrl, useBlob } from '@/hooks/file';
import BusyArea from './busy/BusyArea.vue';

interface Props {
  src?: string;
  file?: Blob;
  busy?: boolean;
  styled?: boolean;
}

const props = defineProps<Props>();
const { blob: srcBlob, loading: srcLoading } = useBlob(computed(() => props.src));
const loading = computed(() => props.busy || srcLoading.value);
const url = useObjectUrl(srcBlob);
const file = useObjectUrl(computed(() => props.file));
const mimeType = computed(() => (props.file ? props.file.type : srcBlob.value?.type));
</script>

<style lang="scss" scoped>
.loading {
  @apply w-full h-full;
  @apply flex items-center justify-center;
}

.styled {
  @apply border border-element-neutral bg-background-light;
  @apply rounded-4;
}

.error {
  @apply w-full h-full;
  @apply flex flex-col items-center justify-center justify-center;
  @apply gap-y-2;
  @apply border-primary;
  @apply text-primary;

  :deep(svg) {
    @apply w-5 h-5;
  }
}
</style>
